import { AuthSession } from '../domain/entities/AuthSession';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { TOKEN_TYPE } from '../constants/constants';

export interface IAuthSession {
    token: string;
    expiration: number;
    source?: string;
    email?: string;
}

export class UpdateAuthSessionUseCase {
    private authSession: AuthSession;
    private data: IAuthSession;

    constructor(data: IAuthSession) {
        this.data = data;
        this.authSession = diContainer.get(serviceNames.authSession);
    }

    public execute = () => {
        const authSession = new AuthSession(this.data.token, TOKEN_TYPE.USER, this.data.expiration);
        this.authSession.updateAuthSession(authSession);
        this.authSession.setAuthSourceData(this.data);
    };
}
